<template>
  <b-modal
      v-model="show"
      id="modal-lg"
      size="lg"
      body-class="p-0"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
  >
    <template #modal-header="{ }">
      <h5 class="fw-bold fs-5 text-dark">Tệp tin đính kèm</h5>
      <div class="text-end">
        <b-button variant="light" size="sm" style="width: 80px" @click="handleClose">
          Đóng
        </b-button>
      </div>
    </template>
    <div class="card-body pb-0 pt-0">
      <div class="row mb-3">
        <div class="col-md-12"
             style="display: flex; flex-direction: column; padding: 0px"
        >
          <div
              v-if="files && files.length > 0"
          >
            <div
                v-for="(value, index) in files" :key="index"
                style="background-color: rgba(47,147,224,0.2); border-radius: 3px; padding: 5px; margin-bottom: 5px"
                class="d-flex"
            >
              <a
                  :href="`${apiUrl}files/view/${value.fileId}/${date}`"
                  class=" fw-medium"
              ><i
                  class="fas fa-cloud-download-alt"
              ></i>
                [Tải về]</a
              >
              <div v-if="value.ext == '.pdf'">
                <a
                    target="_blank"
                    class="fw-medium text-danger"
                    @click="handleShowFile(value.fileId)"
                    style="cursor: pointer"
                >
                  [Xem]</a>
              </div>
              <span style="padding-left: 20px; font-weight: 500; color: #2F93E0">{{ value.fileName }}</span>
            </div>
          </div>
          <div v-else>Không có tệp tin đính kèm</div>
        </div>
      </div>

    </div>
  </b-modal>
</template>

<script>
export default {
  name: "listFile",
  props:['files', 'showModal', 'date'],
  data(){
    return{
      url:  process.env.VUE_APP_API_URL + 'files/view/',
      apiUrl: process.env.VUE_APP_API_URL,
      show: this.showModal
    }
  },
  watch:{
    showModal: function(newValue, oldValue){
      this.show = newValue;
    }
  },
  methods:{
    handleClose(){
      this.show = false
      this.$emit('update:showModal', false)
    },
    handleShowFile(id) {
      let route = this.$router.resolve({path: '/xem-tep-tin/' + id});
      window.open(route.href, '_blank');
    },
  }
}
</script>

<style scoped>

</style>
